
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WalletOutline extends Vue {
  @Prop({ default: '20' }) readonly size?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
